// extracted by mini-css-extract-plugin
export default {"eachPageHeaderCover":"eachPageHeader_eachPageHeaderCover__-WlBs","eachPageHeader":"eachPageHeader_eachPageHeader__hMfp2"};